const chatwoot = {
    // URL base da instancia Chatwoot self-hosted.
    baseURL:
        import.meta.env.VITE_APP_CHATWOOT_BASE_URL || '',
    // Token do Inbox (tipo Website). Publico por design — vai no frontend.
    websiteToken: import.meta.env.VITE_APP_CHATWOOT_WEBSITE_TOKEN || '',
    // Habilita/desabilita o widget sem precisar remover o codigo.
    // Fail-closed: sem a env setada (ou com qualquer valor != 'true'),
    // o widget fica desligado — evita subir o chat por acidente em
    // ambiente onde o inbox/HMAC ainda nao foi configurado.
    enabled: import.meta.env.VITE_APP_CHATWOOT_ENABLED === 'true'
}

export default chatwoot
